import { GroupMemberShow, GroupMemberCreate, GroupMemberEdit } from "./group_members"

export const groupMembersResource = {
  show: GroupMemberShow,
  create: GroupMemberCreate,
  edit: GroupMemberEdit,
}

export default groupMembersResource
